module.exports = __webpack_public_path__ + "202336:0ab57eca5a8d3a1f525a/img/hero-mobile@2x.15234e9.jpg";